import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Compbaser} from "../../../components/compbaser";
import {animate, style, transition, trigger} from "@angular/animations";
import {loginUrlType} from "../../../interfaces";

@Component({
    selector: 'app-started-template',
    templateUrl: './started-template.component.html',
    styleUrls: ['./started-template.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({opacity: 0}),
                animate('300ms ease-in-out')
            ])
        ])
    ]
})
export class StartedTemplateComponent extends Compbaser {
    accountType: string;

    // setMode: loginUrlType;

    constructor(private route: ActivatedRoute, public router: Router) {
        super();
        this.route.paramMap.subscribe((routeParams) => {
            // this.setMode = routeParams.get('mode');
            // this.accountType = routeParams.get('id');
        });
    }

}
